import Vue from "vue";
import VueRouter from "vue-router";
import Authentication from "./middlewares/authentication";
import store from "../store";

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "modules",
      meta: { ignorePermission: true },
      component: () => import("../modules/pendings")
    },
    {
      path: "/pre-registro",
      name: "register",
      meta: { requireAuth: false },
      component: () => import("../modules/auth/register")
    },
    {
      path: "/visualizar",
      name: "visualizar",
      meta: { gfsAuth: true },
      component: () => import("../modules/auth/register")
    },
    {
      path: "/autenticacao",
      name: "auth.login",
      meta: { requireAuth: false },
      component: () => import("../modules/auth")
    },
    {
      path: "/fornecedores/:id?/editar",
      name: "providers.edit",
      meta: { gfsAuth: true },
      component: () => import("../modules/providers")
    },
    {
      path: "/fornecedores/:id/visualizar",
      name: "providers.visualizar",
      meta: { gfsAuth: true },
      component: () => import("../modules/providers")
    },
    {
      path: "/fornecedores/:id/validar/visualizar",
      name: "providers.validation.visualizar",
      meta: { gfsAuth: true },
      component: () => import("../modules/providers")
    },
    {
      path: "/fornecedores/:id/validar",
      name: "providers.validation",
      meta: { gfsAuth: true },
      component: () => import("../modules/providers")
    },
    {
      path: "/processos",
      name: "process.index",
      component: () => import("../modules/process")
    },
    {
      path: "/usuarios",
      name: "users.index",
      component: () => import("../modules/users")
    },
    {
      path: "/usuarios/criar",
      name: "users.create",
      component: () => import("../modules/users/_components/form/form.vue")
    },
    {
      path: "/usuarios/:userId/editar",
      name: "users.edit",
      component: () => import("../modules/users/_components/form/form.vue")
    },
    {
      path: "/usuarios/:userId/visualizar",
      name: "users.view",
      component: () => import("../modules/users/_components/form/form.vue")
    },
    {
      path: "/usuario",
      name: "user.index",
      component: () => import("../modules/users/_components/form/form.vue")
    },
    {
      path: "/comunicados",
      name: "communications.index",
      component: () => import("../modules/communications/index.vue")
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  let authorized = false;
  let nextRoute = "";
  const lang = document.querySelector('html').getAttribute('lang')

  if (lang === 'en') {
    window.location.reload()
  }

  if (
    to.meta.requireAuth === false ||
    (to.meta.gfsAuth &&
      to.query.user_gfs_token &&
      (await Authentication.verifyAuth(to.query.user_gfs_token)))
  )
    authorized = true;
  else if (
    (await Authentication.verifyAuth()) &&
    (to.meta.ignorePermission || Vue.can("view", to) || Vue.can("edit", to))
  ) {
    authorized = true;
  } else {
    authorized = false;
    nextRoute = "auth.login";
    store.commit("$_auth/DELETE_ME_AUTHENTICATED");
  }

  if (authorized) {
    next();
  } else {
    next({ name: nextRoute });
  }
});

export default router;
